import apiClient from '../apiClient';

/**
 * Get site settings (admin)
 * @returns {Promise<Object>} Settings
 */
export const getSettings = async () => {
  try {
    const response = await apiClient.get('/admin/settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

/**
 * Update site settings
 * @param {Object} payload - Settings payload
 * @returns {Promise<Object>} Updated settings
 */
export const updateSettings = async (payload) => {
  try {
    const response = await apiClient.put('/admin/settings', payload);
    return response.data;
  } catch (error) {
    console.error('Error updating settings:', error);
    throw error;
  }
};
